import React, { useEffect, useState, useLayoutEffect, } from 'react'
import { Layout, Row, Col, } from 'antd';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AuthLayout } from '../components/Auth/layouts/AuthLayout';
import { ForgotPassword } from '../pages/Auth/ForgotPassword';
import { ResetPassword } from '../pages/Auth/ResetPassword';
import { Login } from '../pages/Auth/Login';
import { SignUp } from '../pages/Auth/SignUp';
import { VerifyCode } from '../pages/Auth/VerifyCode';
import { LOGIN_VERSION } from '../Constants';
import { getServerType } from '../services/MainService';
import { webSocket } from '../services/socket';
import { ErrorScreen } from '../pages/Dashboard/ErrorScreen';

const layoutStyle = {
    // backgroundColor: 'var(--primary-color)',
    minHeight: '100vh',
    height: '100%',
    padding: '5% 0',
};

const contentStyle = {
    backgroundColor: 'white', 
    padding: 25, 
    borderRadius: 8, 
    border: '0.5px solid rgba(0,0,0,0.1)'
};

export const GeneralRoutes = () => {

    const [loginVersion, setLoginVersion] = useState(null);
    const [enable2FA, setEnable2FA] = useState(false);
    const [displayError, setDisplayError] = useState(false);

    const navigate = useNavigate();

    webSocket.onopen = () => {
        getServerType().then(function(response) {
            setLoginVersion(response?.server)
        })
    };

    useEffect(() => {
        webSocket.onclose = (event) => {
            setDisplayError(event);
        }
    }, []);

    useEffect(() => {
        if(displayError){
            navigate(`/error?code=${displayError.reason}`)
        }
    }, [displayError])

    return (
        <>
            <Layout style={layoutStyle}>
                <Row justify='center' align='middle'>
                    <Col style={contentStyle}>
                        <AuthLayout/>
                        <div className="">
                            {/* Unauthenticated routes */}
                            <Routes>
                                <Route path="/" element={ <Login version={loginVersion} enable2FA={enable2FA} setEnable2FA={setEnable2FA} /> } />
                                <Route path="/forgot-password" element={ <ForgotPassword version={loginVersion} /> } />
                                <Route path='/reset-password' element={<ResetPassword />} />
                                
                                {/* { (displayError || sessionStorage.getItem('showDisplayError')) && */}
                                    {/* <Route path='error' element={<ErrorScreen/>} /> */}
                                {/* } */}
                                
                                <Route path='/error' element={<ErrorScreen/>} />

                                { loginVersion === LOGIN_VERSION.cloud1x &&
                                    <Route exact path="/signup" element={ <SignUp /> } />
                                }

                                { loginVersion === LOGIN_VERSION.cloud1x && 
                                    <Route path="/verify-code" element={ <VerifyCode enable2FA={enable2FA} setEnable2FA={setEnable2FA}/> } />
                                }
                                
                                {/* catch-all route */}
                                <Route path="*" element={<Navigate to="/error?code=404" replace />}/>
                            </Routes>
                        </div> 
                    </Col>
                </Row>
            </Layout>
        </>
    )
}
